import { render, staticRenderFns } from "./RcWidgetLiveResultsSenate.vue?vue&type=template&id=47014742&"
import script from "./RcWidgetLiveResultsSenate.vue?vue&type=script&lang=js&"
export * from "./RcWidgetLiveResultsSenate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports